import { render, staticRenderFns } from "./ListTheftPolice.vue?vue&type=template&id=43d68b63"
import script from "./ListTheftPolice.vue?vue&type=script&lang=js"
export * from "./ListTheftPolice.vue?vue&type=script&lang=js"
import style0 from "./ListTheftPolice.vue?vue&type=style&index=0&id=43d68b63&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports